import { getHashConfig } from '~src/bootstrap/hash-config';

export interface BootstrapConfig {
  creator: string;
  auth_token: string;
  country: string;
  currency: string;
  locales: string[];
}

export const bootstrapConfig = getHashConfig<BootstrapConfig>();
